import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Form from 'react-bootstrap/Form';
import { Col, Container, Row, Button, Spinner, OverlayTrigger, Popover } from 'react-bootstrap';
import ChemComponent from '../ChemComponent';
import { withRouter } from '../withRouter';
import ChemEdit from '../ChemEdit';
import QueryTable from '../QueryTable';
import HashLink from '../HashLink';
import Tabs from '../Tabs';
import { PencilSquare, PlusSquare } from 'react-bootstrap-icons';

class Chemicals extends ChemComponent {
	constructor(props) {
		super(props);

		this.state = {
			chemList: this.copyTable(chemList),
			search: {
				CHEM_NAME: '',
				CHEM_ID: '',
				CAS_NUMBER: '',
				CHEM_CLASS: [],
				CHEM_STATE: [],
				STORAGE: null,
				CATALOG_YEAR: '',
				CATALOG_NAME: [],
				MODIF_DATE: null,
				DELETE_FLAG: false,
				FORMULA: false,
				ELEMENT: ['C','H','O','N',null,null],
				RELATION: ['>=','>=','>=','>=','>=','>='],
				NUMBER: ['','','','','',''],
				EXCLUSION: false,
				EXCLUDE: [null, null],
 				BF4: false,
 				BH3: false,
 				Br2: false,
 				C2H4O: false,
 				C2H4O2: false,
 				C4H6O6: false,
 				C4H8O: false,
 				C6H13N: false,
 				CH4SO3: false,
 				CO: false,
 				ClO4: false,
 				H2CO3: false,
 				H2O: false,
 				H2O2: false,
 				H2SO4: false,
 				H3PO4: false,
 				HBr: false,
 				HBr3: false,
 				HCO2: false,
 				HCl: false,
 				HF: false,
 				HNO3: false,
 				LiBr: false,
 				LiCl: false,
				NH3: false,
				NH4: false,
				NO3: false,
				Na: false,
 				FLASH_POINT_FROM: '',
 				FLASH_POINT_TO: '',
 				MELTING_POINT_FROM: '',
 				MELTING_POINT_TO: '',
 				BOILING_POINT_FROM: '',
 				BOILING_POINT_TO: '',
 				HAZARD: '',
 				COLOR: '',
 				INHIBITOR: ''
			},
			showSearch: true,
			searchCount: 0,
			renderKey: 0
		};
	}
	
	onChangeSearch(accessor, value) {
		var search = this.copyObject(this.state.search);
		this.setByAccessor(search, accessor, value);
		this.mergeState({ search: search });
	}
	
	onExpandSearch(event) {
		this.mergeState({
			showSearch: true,
			chemList: this.copyTable(chemList),
			renderKey: this.state.renderKey + 1
		});
		if (event && event.nativeEvent && event.nativeEvent.submitter) event.nativeEvent.submitter.blur();		
	}

	onSubmitSearch(event) {
		var newChemList = this.copyTable(chemList);
		newChemList.ajax.data = {
			search: this.copyObject(this.state.search)
		};
		newChemList.hold = false;
		newChemList.ajax.data.search.COMPLEX = this.getComplexArray(newChemList.ajax.data.search);
		this.mergeState({ 
			chemList: newChemList,
			showSearch: false,
			searchCount: null,
			renderKey: this.state.renderKey + 1
		});
		if (event && event.nativeEvent && event.nativeEvent.submitter) event.nativeEvent.submitter.blur();
	}
	
	getComplexArray(search) {
		var complex = [];
		
		if (search.BF4) complex.push('BF4');
		if (search.BH3) complex.push('BH3');
		if (search.Br2) complex.push('Br2');
		if (search.C2H4O) complex.push('C2H4O');
		if (search.C2H4O2) complex.push('C2H4O2');
		if (search.C4H6O6) complex.push('C4H6O6');
		if (search.C4H8O) complex.push('C4H8O');
		if (search.C6H13N) complex.push('C6H13N');
		if (search.CH4SO3) complex.push('CH4SO3');
		if (search.CO) complex.push('CO');
		if (search.ClO4) complex.push('ClO4');
		if (search.H2CO3) complex.push('H2CO3');
		if (search.H2O) complex.push('H2O');
		if (search.H2O2) complex.push('H2O2');
		if (search.H2SO4) complex.push('H2SO4');
		if (search.H3PO4) complex.push('H3PO4');
		if (search.HBr) complex.push('HBr');
		if (search.HBr3) complex.push('HBr3');
		if (search.HCO2) complex.push('HCO2');
		if (search.HCl) complex.push('HCl');
		if (search.HF) complex.push('HF');
		if (search.HNO3) complex.push('HNO3');
		if (search.LiBr) complex.push('LiBr');
		if (search.LiCl) complex.push('LiCl');
		if (search.NH3) complex.push('NH3');
		if (search.NH4) complex.push('NH4');
		if (search.NO3) complex.push('NO3');
		if (search.Na) complex.push('Na');
		return complex;
	}
	
	addChemical() {
		this.props.navigate('/Reuse/Chemicals/new');
	}
	
	editChemical(chemId) {
		this.props.setChemicalEditable(true);
		this.props.navigate('/Reuse/Chemicals/' + chemId);
	}

	viewChemical(chemId) {
		this.props.setChemicalEditable(false);
		this.props.navigate('/Reuse/Chemicals/' + chemId);
	}
	
	onSearchResult(data) {
		this.mergeState({
			searchCount: data.ResultCount
		});
	}
	
	renderElement(idx) {
		return(
			<Container fluid>
				<Row>
					<Col xs={5} style={{ marginBottom: '14px' }}>
						<Form.Control as="select" value={this.getByAccessor(this.state.search, 'ELEMENT[' + idx + ']')}
							onChange={(event) => this.onChangeSearch('ELEMENT[' + idx + ']', event.target.value)}>
							{elementList.map((option, optionIdx) => {
								return (<option key={optionIdx} value={option.value}>{option.label}</option>);
							})}
						</Form.Control>
					</Col>
					<Col xs={2} style={{ marginBottom: '14px' }}>
						<Form.Control as="select" value={this.getByAccessor(this.state.search, 'RELATION[' + idx + ']')}
							onChange={(event) => this.onChangeSearch('RELATION[' + idx + ']', event.target.value)}>
							{comparators.map((option, optionIdx) => {
								return (<option key={optionIdx} value={option.value}>{option.label}</option>);
							})}
						</Form.Control>
					</Col>
					<Col xs={5} style={{ marginBottom: '14px' }}>
						<Form.Control type="text" value={this.getByAccessorForInput(this.state.search, 'NUMBER[' + idx + ']')}
							onChange={(event) => this.onChangeSearch('NUMBER[' + idx + ']', event.target.value)} />
					</Col>
				</Row>
			</Container>
		);
	}
	
	renderFormula(formula) {
		var self = this;
		if (this.isEmpty(formula)) return null;
		var elements = formula.match(/([A-Z][a-z]?)([0-9]*)/g);
		if (this.isEmpty(elements) || elements.length === 0) return null;
		return elements.map((element, key) => {
			var elementAndNumber = element.match(/^([A-Z][a-z]?)([0-9]*)$/);
			if (self.isEmpty(elementAndNumber[2])) {
				return (<React.Fragment key={key}>{elementAndNumber[1]}</React.Fragment>);
			} else {
				return (<React.Fragment key={key}>{elementAndNumber[1]}<sub>{elementAndNumber[2]}</sub></React.Fragment>);
			}
		});
	}
	
	renderFormulae(formulae) {
		if (this.isEmpty(formulae)) return '';
		var pmatch = formulae.match(/^\(((?:[a-zA-Z]+[0-9]*)+)\)n(?:\s●\s([a-zA-Z0-9]+)\s((?:[a-zA-Z]+[0-9]*)+))?(?:\s●\s([a-zA-Z0-9]+)\s((?:[a-zA-Z]+[0-9]*)+))?$/);
		var match = formulae.match(/^((?:[a-zA-Z]+[0-9]*)+)(?:\s●\s([a-zA-Z0-9]+)\s((?:[a-zA-Z]+[0-9]*)+))?(?:\s●\s([a-zA-Z0-9]+)\s((?:[a-zA-Z]+[0-9]*)+))?$/);
		if (pmatch) {
			return (<>({this.renderFormula(pmatch[1])})n{!this.isEmpty(pmatch[2]) && <> ● {pmatch[2]} {this.renderFormula(pmatch[3])}</>}{!this.isEmpty(pmatch[4]) && <> ● {pmatch[4]} {this.renderFormula(pmatch[5])}</>}</>);
		} else if (match) {
			return (<>{this.renderFormula(match[1])}{!this.isEmpty(match[2]) && <> ● {match[2]} {this.renderFormula(match[3])}</>}{!this.isEmpty(match[4]) && <> ● {match[4]} {this.renderFormula(match[5])}</>}</>);
		} else {
			return (<>{formulae}</>);
		}
	}

	renderComplex(formula1, formula2, formula3, formula4) {
		return (
			<Container fluid>
				<Row>
					<Col style={{ marginBottom: '14px' }}>
						<Form.Check style={{ paddingTop: '8px' }} type="checkbox"
							checked={this.getByAccessor(this.state.search, formula1)} label={this.renderFormula(formula1)}
							onClick={(event) => this.onChangeSearch(formula1, event.target.checked)} />
					</Col>
					<Col style={{ marginBottom: '14px' }}>
						<Form.Check style={{ paddingTop: '8px' }} type="checkbox"
							checked={this.getByAccessor(this.state.search, formula2)} label={this.renderFormula(formula2)}
							onClick={(event) => this.onChangeSearch(formula2, event.target.checked)} />
					</Col>
					<Col style={{ marginBottom: '14px' }}>
						<Form.Check style={{ paddingTop: '8px' }} type="checkbox"
							checked={this.getByAccessor(this.state.search, formula3)} label={this.renderFormula(formula3)}
							onClick={(event) => this.onChangeSearch(formula3, event.target.checked)} />
					</Col>
					<Col style={{ marginBottom: '14px' }}>
						<Form.Check style={{ paddingTop: '8px' }} type="checkbox"
							checked={this.getByAccessor(this.state.search, formula4)} label={this.renderFormula(formula4)}
							onClick={(event) => this.onChangeSearch(formula4, event.target.checked)} />
					</Col>
				</Row>
			</Container>
		);
	}

	render() {
		
		var exportData = this.createHiddenFormData({
			__RequestVerificationToken: this.props.user.antiForgeryToken,
			Action: 'Chemicals',
			columns: exportColumns,
			search: this.state.search
		});
		
		return (<>
			<Container fluid>
			  <Row>
			    <Col style={{ paddingTop: '20px', marginBottom: '20px', border: '1px solid #ccc', borderRadius: 6, backgroundColor: '#FEFEFE' }}>
				  <Container fluid>	
					<Row>
					  <Col xs={12}>
						<div style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '10px' }}>Chemicals</div>
						<div className='float-end'>α&nbsp;&nbsp;&nbsp;β&nbsp;&nbsp;&nbsp;γ&nbsp;&nbsp;&nbsp;δ&nbsp;&nbsp;&nbsp;ε&nbsp;&nbsp;&nbsp;ζ&nbsp;&nbsp;&nbsp;η&nbsp;&nbsp;&nbsp;θ&nbsp;&nbsp;&nbsp;λ&nbsp;&nbsp;&nbsp;μ&nbsp;&nbsp;&nbsp;ο&nbsp;&nbsp;&nbsp;σ&nbsp;&nbsp;&nbsp;φ&nbsp;&nbsp;&nbsp;ψ&nbsp;&nbsp;&nbsp;ω&nbsp;&nbsp;&nbsp;Ο&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;'&nbsp;&nbsp;&nbsp;"&nbsp;&nbsp;&nbsp;±&nbsp;&nbsp;&nbsp;®&nbsp;&nbsp;&nbsp;©</div>
						{this.state.showSearch && <Tabs>
						  <div label='Chemical'>
							<ChemEdit parent={this} user={this.props.user} columns={chemSearch} data={this.state.search}
							  renderKey={this.state.renderKey} onChange={(accessor, value) => this.onChangeSearch(accessor, value)} />
						  </div>
						  <div label='Formula'>
							<ChemEdit parent={this} user={this.props.user} columns={formulaSearch} data={this.state.search}
							  renderKey={this.state.renderKey} onChange={(accessor, value) => this.onChangeSearch(accessor, value)} />
						  </div>
						  <div label='Additional'>
							<ChemEdit parent={this} user={this.props.user} columns={additionalSearch} data={this.state.search}
							  renderKey={this.state.renderKey} onChange={(accessor, value) => this.onChangeSearch(accessor, value)} />
						  </div>
						</Tabs>}
					  </Col>
					</Row>
					<Form.Group as={Row} style={{ borderTop: '1px solid #eee', paddingTop: 10, marginBottom: 10 }}>
					  <Col xs={3} style={{ marginTop: 8}}>
						{this.isEmpty(this.state.searchCount) ? <Spinner animation='border' as='div' size='sm' style={{ marginRight: '4px' }} /> : this.state.searchCount} records found.
					  </Col>
					  <Col xs={1} style={{ marginTop: 6}}>
						<form action={this.getConfig().host + '/Reuse/Excel'} method='POST'>
							{exportData.map((excelFormField, index) => {
								return (<input key={index} type='hidden' name={excelFormField.name} value={excelFormField.value} />);
							})}
							<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to Excel</Popover.Header></Popover>}>
							  <input type='image' src={this.getConfig().host + '/Content/Icons/Excel.png'} style={{ paddingLeft: '20px' }} alt="Export to Excel" />
							</OverlayTrigger>
						</form>
					  </Col>
					  <Col xs={1} style={{ marginTop: 6}}>
						<form action={this.getConfig().host + '/Reuse/Pdf'} method='POST'>
							{exportData.map((pdfFormField, index) => {
								return (<input key={index} type='hidden' name={pdfFormField.name} value={pdfFormField.value} />);
							})}
							<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to PDF</Popover.Header></Popover>}>
							  <input type='image' src={this.getConfig().host + '/Content/Icons/Pdf.png'} style={{ paddingLeft: '20px' }} alt="Export to PDF" />
							</OverlayTrigger>
						</form>
					  </Col>
					  <Col xs={7}>
						{this.state.showSearch ?
							<Button id="update" variant="warning" type="button" className="float-end" onClick={(event) => this.onSubmitSearch(event)}>Search</Button> :
							<Button id="expand" variant="warning" type="button" className="float-end" onClick={(event) => this.onExpandSearch(event)}>Modify Search</Button>
						}
					  </Col>
					</Form.Group>
				  </Container>
				</Col>
			  </Row>
			  <Row>
				<Col>
				  <QueryTable renderKey={this.state.renderKey} parent={this} name='Reuse_Chemicals' table={this.state.chemList}
				    onResult={(data) => this.onSearchResult(data)} offsetHeight='175px' />
				</Col>
			  </Row>
			</Container>
		</>);		
	}
}

const comparators = [
	{ value: '=', label: '=' },
	{ value: '<=', label: '≤' },
	{ value: '>=', label: '≥' }
];

const elementList = [
	{ value: null, label: 'Select...'},                
	{ value: 'Pb', label: 'Pb'},                
	{ value: 'Mo', label: 'Mo' },                
	{ value: 'Eu', label: 'Eu' },                
	{ value: 'W', label: 'W' },                
	{ value: 'Tl', label: 'Tl' },                
	{ value: 'Ca', label: 'Ca' },                
	{ value: 'Lu', label: 'Lu' },                
	{ value: 'Ho', label: 'Ho' },                
	{ value: 'Ce', label: 'Ce' },                
	{ value: 'B', label: 'B' },                
	{ value: 'Mn', label: 'Mn' },                
	{ value: 'Se', label: 'Se' },                
	{ value: 'C', label: 'C' },                
	{ value: 'Tm', label: 'Tm' },                
	{ value: 'Xe', label: 'Xe' },                
	{ value: 'Sr', label: 'Sr' },                
	{ value: 'Te', label: 'Te' },                
	{ value: 'Nd', label: 'Nd' },                
	{ value: 'Pt', label: 'Pt' },                
	{ value: 'Rh', label: 'Rh' },                
	{ value: 'Sb', label: 'Sb' },                
	{ value: 'F', label: 'F' },                
	{ value: 'I', label: 'I' },                
	{ value: 'Si', label: 'Si' },                
	{ value: 'Br', label: 'Br' },                
	{ value: 'Cl', label: 'Cl' },                
	{ value: 'H', label: 'H' },                
	{ value: 'O', label: 'O' },                
	{ value: 'Ni', label: 'Ni' },                
	{ value: 'Pr', label: 'Pr' },                
	{ value: 'In', label: 'In' },                
	{ value: 'As', label: 'As' },                
	{ value: 'Th', label: 'Th' },                
	{ value: 'Rb', label: 'Rb' },                
	{ value: 'Y', label: 'Y' },                
	{ value: 'Cs', label: 'Cs' },                
	{ value: 'Cr', label: 'Cr' },                
	{ value: 'Sn', label: 'Sn' },                
	{ value: 'N', label: 'N' },                
	{ value: 'P', label: 'P' },                
	{ value: 'Er', label: 'Er' },                
	{ value: 'Gd', label: 'Gd' },                
	{ value: 'Nb', label: 'Nb' },                
	{ value: 'Hf', label: 'Hf' },                
	{ value: 'Yb', label: 'Yb' },                
	{ value: 'Zr', label: 'Zr' },                
	{ value: 'Al', label: 'Al' },                
	{ value: 'Ti', label: 'Ti' },                
	{ value: 'S', label: 'S' },                
	{ value: 'Sm', label: 'Sm' },                
	{ value: 'Ar', label: 'Ar' },                
	{ value: 'Re', label: 'Re' },                
	{ value: 'Ta', label: 'Ta' },                
	{ value: 'Bi', label: 'Bi' },                
	{ value: 'Ru', label: 'Ru' },                
	{ value: 'K', label: 'K' },                
	{ value: 'Ba', label: 'Ba' },                
	{ value: 'Fe', label: 'Fe' },                
	{ value: 'La', label: 'La' },                
	{ value: 'Hg', label: 'Hg' },                
	{ value: 'Tb', label: 'Tb' },                
	{ value: 'Au', label: 'Au' },                
	{ value: 'V', label: 'V' },                
	{ value: 'Li', label: 'Li' },                
	{ value: 'Ag', label: 'Ag' },                
	{ value: 'Cu', label: 'Cu' },                
	{ value: 'Zn', label: 'Zn' },                
	{ value: 'U', label: 'U' },                
	{ value: 'Cd', label: 'Cd' },                
	{ value: 'Ga', label: 'Ga' },                
	{ value: 'Pd', label: 'Pd' },                
	{ value: 'D', label: 'D' },                
	{ value: 'Na', label: 'Na' },                
	{ value: 'Mg', label: 'Mg' },                
	{ value: 'Co', label: 'Co' },                
	{ value: 'Ge', label: 'Ge' },                
	{ value: 'Be', label: 'Be' },                
	{ value: 'Os', label: 'Os' },                
	{ value: 'Dy', label: 'Dy' },                
	{ value: 'Ir', label: 'Ir' },                
	{ value: 'Sc', label: 'Sc' }
];

const chemSearch = [
	{ Header: 'Name', accessor: 'CHEM_NAME', row: 0, col: 0 },
	{ Header: 'ID', accessor: 'CHEM_ID', row: 0, col: 1 },
	{ Header: 'CAS Number', accessor: 'CAS_NUMBER', row: 1, col: 0 },
	{ Header: 'Class', accessor: 'CHEM_CLASS', type: 'list', row: 1, col: 1,
		options: { value: 'CLASS_ID', label: 'CLASS_NAME', entity: 'REUSE.CHEM_CLASS', order: 'CLASS_ID' }},
	{ Header: 'State', accessor: 'CHEM_STATE', type: 'list', row: 2, col: 0,
		options: [
			{ value: 'liquid', label: 'Liquid' },
			{ value: 'solid', label: 'Solid' },
			{ value: 'gas', label: 'Gas' }
		]},
	{ Header: 'Storage Temp', accessor: 'STORAGE', type: 'select', row: 2, col: 1,
		options: { value: 'TEMP_ID', label: 'TEMP_NAME', entity: 'REUSE.STORAGE_TEMP' }},
	{ Header: 'Catalog Year', accessor: 'CATALOG_YEAR', row: 3, col: 0 },
	{ Header: 'Catalog', accessor: 'CATALOG_NAME', type: 'list', row: 3, col: 1,
		options: { value: 'CATALOG_NAME', label: 'CATALOG_NAME', entity: 'REUSE.CHEMICAL', distinct: true, order: 'CATALOG_NAME' }},
	{ Header: 'Modified', accessor: 'MODIF_DATE', type: 'select', row: 4, col: 0,
		options: [
			{ value: '', label: 'Select...' },
			{ value: new Date(new Date().setDate(new Date().getDate() - 2)).toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' }), label: 'Past 24 hours' },
			{ value: new Date(new Date().setDate(new Date().getDate() - 8)).toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' }), label: 'Past 7 days' },
			{ value: new Date(new Date().setDate(new Date().getDate() - 31)).toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' }), label: 'Past 30 days' },
			{ value: new Date(new Date().setDate(new Date().getDate() - 181)).toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' }), label: 'Past 6 months' },
			{ value: new Date(new Date().setDate(new Date().getDate() - 366)).toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' }), label: 'Past year' },
		]},
	{ Header: 'Include Deleted', accessor: 'DELETE_FLAG', type: 'checkbox', row: 4, col: 1 },
];

const formulaSearch = [
	{ Header: '<b>Search by Formula</b>', accessor: 'FORMULA', type: 'checkbox', row: 0, col: 0 },
	{ Editor: props => props.parent.renderComplex('BF4', 'C6H13N', 'H2SO4', 'HNO3'), row: 0, col: 2 },
	{ Editor: props => props.parent.renderElement(0), row: 1, col: 0 },
	{ Editor: props => props.parent.renderComplex('BH3', 'CH4SO3', 'H3PO4', 'LiBr'), row: 1, col: 2 },
	{ Editor: props => props.parent.renderElement(1), row: 2, col: 0 },
	{ Header: 'Exclude', accessor: 'EXCLUSION', type: 'checkbox', label: 'all other elements', row: 2, col: 1 },
	{ Editor: props => props.parent.renderComplex('Br2', 'CO', 'HBr', 'LiCl'), row: 2, col: 2 },
	{ Editor: props => props.parent.renderElement(2), row: 3, col: 0 },
	{ Header: 'Exclude', accessor: 'EXCLUDE[0]', type: 'select', options: elementList, row: 3, col: 1 },
	{ Editor: props => props.parent.renderComplex('C2H4O', 'ClO4', 'HBr3', 'NH3'), row: 3, col: 2 },
	{ Editor: props => props.parent.renderElement(3), row: 4, col: 0 },
	{ Header: 'Exclude', accessor: 'EXCLUDE[1]', type: 'select', options: elementList, row: 4, col: 1 },
	{ Editor: props => props.parent.renderComplex('C2H4O2', 'H2CO3', 'HCO2', 'NH4'), row: 4, col: 2 },
	{ Editor: props => props.parent.renderElement(4), row: 5, col: 0 },
	{ Editor: props => props.parent.renderComplex('C4H6O6', 'H2O', 'HCl', 'NO3'), row: 5, col: 2 },
	{ Editor: props => props.parent.renderElement(5), row: 6, col: 0 },
	{ Editor: props => props.parent.renderComplex('C4H8O', 'H2O2', 'HF', 'Na'), row: 6, col: 2 }
];

const additionalSearch = [
	{ Header: 'Flash Point ≥', accessor: 'FLASH_POINT_FROM', row: 0, col: 0 },
	{ Header: 'Flash Point ≤', accessor: 'FLASH_POINT_TO', row: 0, col: 1 },
	{ Header: 'Melting Point ≥', accessor: 'MELTING_POINT_FROM', row: 1, col: 0 },
	{ Header: 'Melting Point ≤', accessor: 'MELTING_POINT_TO', row: 1, col: 1 },
	{ Header: 'Boiling Point ≥', accessor: 'BOILING_POINT_FROM', row: 2, col: 0 },
	{ Header: 'Boiling Point ≤', accessor: 'BOILING_POINT_TO', row: 2, col: 1 },
	{ Header: 'Hazard', accessor: 'HAZARD', row: 3, col: 0 },
	{ Header: 'Color', accessor: 'COLOR', row: 3, col: 1 },
	{ Header: 'Inhibitor', accessor: 'INHIBITOR', row: 4, col: 0 }
];

const chemList = {
	ajax: { 
		url: '/Reuse/ChemSearch',
		data: null,
		accessor: 'Data'
	},
	hold: true,
	pageSize: 20,
	columns: [
		{ Header: props => <PlusSquare style={{ cursor: 'pointer' }} onClick={() => props.parent.addChemical()} />, accessor: 'id', width: 25, 
			Cell: props => <PencilSquare style={{ cursor: 'pointer' }} onClick={() => props.parent.editChemical(props.row.values.CHEM_ID)} /> },	
		{ Header: 'ID', accessor: 'CHEM_ID', width: 70,
			Cell: props => <HashLink onClick={() => props.parent.viewChemical(props.row.values.CHEM_ID)}>{props.value}</HashLink> },
		{ Header: 'Name', accessor: 'CHEM_NAME', width: 300 },
		{ Header: 'CAS', accessor: 'CAS_NUMBER', width: 125 },
		{ Header: 'Formula', accessor: 'FORMULA', Cell: props => props.parent.renderFormulae(props.value), width: 200 },
		{ Header: 'State', accessor: 'CHEM_STATE', width: 80 },
		{ Header: 'Melting Pt.', accessor: 'MELTING_POINT', width: 90 },
		{ Header: 'Flash Pt.', accessor: 'FLASH_POINT', width: 80 },
		{ Header: 'Storage', accessor: 'STORAGE', width: 150 },
		{ Header: 'Catalog', accessor: 'CATALOG_NAME', width: 125 },
		{ Header: 'Class', accessor: 'CLASS_NAME', width: 100 }
	]
};

const exportColumns = [
	{ Header: 'ID', accessor: 'CHEM_ID', width: 14 },
	{ Header: 'Name', accessor: 'CHEM_NAME', width: 60 },
	{ Header: 'CAS', accessor: 'CAS_NUMBER', width: 25 },
	{ Header: 'Formula', accessor: 'FORMULA', width: 40 },
	{ Header: 'State', accessor: 'CHEM_STATE', width: 16 },
	{ Header: 'Melting Pt.', accessor: 'MELTING_POINT', width: 18 },
	{ Header: 'Flash Pt.', accessor: 'FLASH_POINT', width: 16 },
	{ Header: 'Storage', accessor: 'STORAGE', width: 30 },
	{ Header: 'Catalog', accessor: 'CATALOG_NAME', width: 25 },
	{ Header: 'Class', accessor: 'CLASS_NAME', width: 20 }
];

export default withRouter(Chemicals);
